// @flow

export const isEmpty = (o: Object): boolean => {
  return JSON.stringify(o) === '{}';
};

export const clone = (o: Object): Object => {
  return JSON.parse(JSON.stringify(o));
};
